import { SampleProjectCard } from './sample-project-card';

export function CaseStudies() {
  return (
    <section 
      id="projects"
      className="py-20 px-6 md:px-12 lg:px-16"
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-body text-lg font-light text-foreground mb-4">
            PROJECTS
          </h2>
          <p className="font-heading text-5xl text-foreground">
            Selected Work
          </p>
          <p className="font-body text-sm text-muted-foreground mt-5 max-w-xl mx-auto leading-relaxed">
            A growing collection of practical products, platforms, and automation systems.
          </p>
        </div>
        <SampleProjectCard />
      </div>
    </section>
  );
}
